<template>
    <div class="chapters-modal flex flex-column" :theme="theme">
        <input type="text" placeholder="Search Book..." v-model="search" class="search" ref="search" @keydown.esc="close" />
        <div class="ff chapters-list scroll">
            <toc :chapters="product.product_contents" :search="search" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Chapters',
        data(){
            return {
                search: ''
            };
        },
        computed: {
            theme(){
                return this.$store.state.theme.active;
            },
            product(){
                return this.$store.getters.product;
            }
        },
        methods: {
            close(){
                this.$emit('close');
            }
        },
        watch: {
            '$route.fullPath': {
                handler(){
                    this.$emit('close');
                }
            }
        },
        mounted(){
            this.$refs.search.focus();
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .chapters-modal
    {
        background: var(--background-color);
        border-radius: 3px;
        padding: 20px 20px 0;
        width: 100%;
        height: 100%;
    }

    .chapters-list
    {
        padding-left: 50px;

        .text-button
        {
            display: none;
        }
    }
</style>
